import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MainHero from "./sections/MainHero";
import BeautifulImageElement from "./sections/BeautifulImageElement";
import SrokZaPriemaneNaPorachki from "./sections/SrokZaPriemaneNaPorachki";
import OrderForm from "./sections/OrderForm";
import OrderSubmissionForm from "./sections/OrderSubmissionForm";
import FullOrderFormHome from "./sections/FullOrderFormHome";
import DeliveryRegions from "./sections/DeliveryRegions";
import BeautifulImageCarousel from "./sections/BeautifulImageCarousel";
import AboutUsOverview from "./sections/AboutUsOverview";
import EventsOverview from "./sections/EventsOverview";
import NapraveetePorachka from "./sections/NapraveetePorachka";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MainHero />
      <BeautifulImageElement />
      <SrokZaPriemaneNaPorachki />
      <OrderForm />
      <OrderSubmissionForm />
      <DeliveryRegions />
      <FullOrderFormHome />
      <BeautifulImageCarousel />
      <AboutUsOverview />
      <EventsOverview />
      <NapraveetePorachka />
      <Footer />
    </div>;
}